export default __webpack_public_path__ + "static/media/careernav02.3b99b622.jpg";